import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationStageGuard } from './ecp-shared/guards/application-stage-guard';
import { PreventApplicatinBackGuard } from './ecp-shared/guards/restrict-back-from-application.guard';
import { ApplicationExperienceGuard } from './ecp-shared/guards/application-experience-guard.service';
import { OLAPreventApplicatinBackGuard } from './ecp-shared/guards/ola-restrict-back-from-application.guard';
import { IdentificationCheckGuard } from './ecp-shared/guards/identification-check.guard';
import { RequiredPagesCompleteAsyncGuard } from './guards/required-pages-complete-async.guard';
import { AlloyCheckGuard } from './ecp-shared/guards/alloy-check.guard';
import { PreventAutofillRevisitGuard } from './ecp-shared/guards/prevent-autofill-revisit.guard';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
  providers: [
    ApplicationStageGuard,
    PreventApplicatinBackGuard,
    ApplicationExperienceGuard,
    RequiredPagesCompleteAsyncGuard,
    OLAPreventApplicatinBackGuard,
    IdentificationCheckGuard,
    AlloyCheckGuard,
    PreventAutofillRevisitGuard
  ]
})
export class WorkflowGuardsModule {}
